import moment from "moment";

const prefix = "grazianiindustriacache";
const expiryInMinutes = 5;

const store = async (key, value) => {
  try {
    const item = {
      value,
      timestamp: Date.now(),
    };

    await localStorage.setItem(prefix + key, JSON.stringify(item));
  } catch (error) {
    console.log("Errore cache: ", error);
  }
};

const isExpired = (item) => {
  const now = moment();
  const storedTime = moment(item.timestamp);
  return now.diff(storedTime, "minute") > expiryInMinutes;
};

const get = async (key) => {
  try {
    const value = await localStorage.getItem(prefix + key);
    const item = JSON.parse(value);

    if (!item) return null;

    if (isExpired(item)) {
      // Command Query Separation (CQS)
      await localStorage.removeItem(prefix + key);
      return null;
    }

    return item.value;
  } catch (error) {
    console.log(error);
  }
};
const exported = {
  store,
  get,
};
export default exported;
